import { z } from 'zod';
import type { AISchemaField, UISchemaField } from '../types/index';

/**
 * 登壇者紹介セクション — 一人の登壇者にスポットを当てる構成。
 * イベント告知・セミナー LP の中核セクションとして使う。
 */
export const speakerAISchema: AISchemaField[] = [
  { name: 'eyebrow', type: 'string', required: false, max: 30, hint: '例: 登壇者紹介 / Speaker' },
  { name: 'name', type: 'string', required: true, max: 40, hint: '登壇者の氏名' },
  { name: 'title', type: 'string', required: true, max: 80, hint: '肩書き・所属（例: 株式会社X CEO）' },
  { name: 'bio', type: 'string', required: true, max: 600, hint: '紹介本文。実績・経歴・登壇テーマなど 2-4 段落' },
  { name: 'avatar', type: 'image_url', required: false },
  { name: 'subTitle', type: 'string', required: false, max: 80, hint: '副肩書き（受賞歴など、任意）' },
];

export const speakerUISchema: UISchemaField[] = [
  { name: 'eyebrow', type: 'text', label: 'アイブロウ', max: 30 },
  { name: 'name', type: 'text', label: '氏名', required: true, max: 40 },
  { name: 'title', type: 'text', label: 'タイトル / 肩書き', required: true, max: 80 },
  { name: 'subTitle', type: 'text', label: 'サブタイトル', max: 80 },
  { name: 'bio', type: 'textarea', label: '紹介本文', required: true, max: 600 },
  { name: 'avatar', type: 'image', label: '写真' },
];

export const speakerZodSchema = z.object({
  eyebrow: z.string().max(30).optional().nullable(),
  name: z.string().min(1).max(40),
  title: z.string().min(1).max(80),
  subTitle: z.string().max(80).optional().nullable(),
  bio: z.string().min(1).max(600),
  avatar: z.string().optional().nullable(),
});

export type SpeakerContent = z.infer<typeof speakerZodSchema>;

export const speakerSample: SpeakerContent = {
  eyebrow: 'Speaker',
  name: '寺岡 友亀',
  title: 'caudesign.jp / 代表',
  subTitle: 'AIプラットフォーム開発・経営者向けコーチ',
  bio: '量子場とAIを統合した意思決定支援システムを開発。延べ500名以上の経営者の戦略立案を支援。\n\n本セッションでは「選択のズレ」を可視化し、根本的な意思決定の質を高めるアプローチを実演します。',
  avatar: null,
};
